<template>
  <div class="vip-page">
    <!-- 顶部横幅 -->
    <div class="vip-header">
      <div class="vip-logo">
        <div class="logo-icon">
          <svg viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 50 Q30 10 50 30 Q70 50 90 30" stroke="#000" stroke-width="8" fill="none" stroke-linecap="round"/>
            <path d="M15 45 Q35 15 50 30" stroke="#000" stroke-width="6" fill="none" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="logo-text">
          <div class="brand-name">Nano Banana</div>
          <div class="brand-desc">图片编辑神器</div>
        </div>
      </div>
    </div>

    <!-- 套餐标题 -->
    <div class="package-section">
      <h2 class="package-title">
        <span class="title-icon">⎯</span>
        选择服务套餐
        <span class="title-icon">⎯</span>
      </h2>
    </div>

    <!-- 套餐列表 -->
    <div class="packages-list">
      <!-- 单次服务 -->
      <div 
        class="package-item" 
        :class="{ selected: selectedPackage === 'single' }"
        @click="selectedPackage = 'single'"
      >
        <div class="badge">推荐</div>
        <div class="package-amount">单次图片生成</div>
        <div class="package-price">
          <span class="currency">¥</span>
          <span class="price">3</span>
        </div>
        <div class="package-original-price">原价 5.00</div>
        <div class="package-unit">每次生成 1 张图片</div>
      </div>

      <!-- 5 次卡 -->
      <div 
        class="package-item" 
        :class="{ selected: selectedPackage === '5times' }"
        @click="selectedPackage = '5times'"
      >
        <div class="package-amount">5 次卡</div>
        <div class="package-price">
          <span class="currency">¥</span>
          <span class="price">13</span>
        </div>
        <div class="package-original-price">原价 15.00</div>
        <div class="package-unit">仅需¥2.6/次</div>
      </div>

      <!-- 10 次卡 -->
      <div 
        class="package-item" 
        :class="{ selected: selectedPackage === '10times' }"
        @click="selectedPackage = '10times'"
      >
        <div class="package-amount">10 次卡</div>
        <div class="package-price">
          <span class="currency">¥</span>
          <span class="price">25</span>
        </div>
        <div class="package-original-price">原价 30.00</div>
        <div class="package-unit">仅需¥2.5/次</div>
      </div>
    </div>

    <!-- 服务说明 -->
    <div class="benefits-section">
      <div class="benefit-item">
        <div class="benefit-icon">✓</div>
        <span class="benefit-text">单次付费，无会员套路</span>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">✓</div>
        <span class="benefit-text">支持多模型图片生成</span>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">✓</div>
        <span class="benefit-text">高清画质，快速生成</span>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">✓</div>
        <span class="benefit-text">购买次数永久有效</span>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">✓</div>
        <span class="benefit-text">7 天内免费售后修改</span>
      </div>
    </div>

    <!-- 底部支付区域 -->
    <div class="payment-section">
      <div class="payment-info">
        <span class="payment-label">支付</span>
        <span class="payment-amount">
          <span class="currency">¥</span>
          <span class="amount">{{ currentPrice }}</span>
        </span>
      </div>
      <button class="pay-button" @click="handlePay">
        立即支付
      </button>
    </div>

    <!-- 协议提示 -->
    <div class="agreement-tip">
      支付即代表同意 <button class="agreement-link">《服务协议》</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipPage',
  data() {
    return {
      selectedPackage: 'single',
      packages: {
        'single': 3,    // 单次 3 元
        '5times': 13,   // 5 次卡 13 元
        '10times': 25   // 10 次卡 25 元
      },
      packageTimes: {
        'single': 1,
        '5times': 5,
        '10times': 10
      }
    };
  },
  computed: {
    currentPrice() {
      return this.packages[this.selectedPackage] || 0;
    }
  },
  methods: {
    handlePay() {
      // 获取用户信息
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        alert('请先登录');
        return;
      }
      const user = JSON.parse(userStr);
      
      // 发起支付
      fetch('/api/wechat/pay', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId: user.id,
          amount: this.currentPrice,
          times: this.packageTimes[this.selectedPackage] // 购买次数
        })
      })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          // 调用微信支付
          if (typeof wx !== 'undefined') {
            wx.requestPayment({
              ...data.payParams,
              success: function(res) {
                alert('支付成功！');
                // 更新本地存储的次数
                user.times = (user.times || 0) + this.packageTimes[this.selectedPackage];
                localStorage.setItem('user', JSON.stringify(user));
              },
              fail: function(err) {
                alert('支付失败：' + err.errMsg);
              }
            });
          } else {
            alert('支付环境未就绪，请联系管理员');
          }
        } else {
          alert('发起支付失败：' + data.error);
        }
      })
      .catch(err => {
        console.error('支付失败:', err);
        alert('支付失败，请稍后重试');
      });
    }
  }
};
</script>

<style scoped>
.vip-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff8f0 0%, #faf8f5 100%);
  padding: 20px;
  padding-bottom: 140px;
}

.vip-header {
  text-align: center;
  padding: 20px 0;
}

.vip-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-icon {
  width: 100px;
  height: 60px;
  background: linear-gradient(135deg, #ffeb3b 0%, #ffc107 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
}

.logo-icon svg {
  width: 80px;
  height: 50px;
}

.logo-text {
  text-align: center;
}

.brand-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.brand-desc {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.package-section {
  text-align: center;
  padding: 30px 0 20px;
}

.package-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.title-icon {
  color: #ff9500;
}

.package-tabs {
  display: flex;
  background: white;
  border-radius: 8px;
  padding: 4px;
  margin: 20px auto;
  max-width: 300px;
}

.package-tab {
  flex: 1;
  text-align: center;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.package-tab.active {
  background: linear-gradient(135deg, #ff9500 0%, #ffb347 100%);
  color: white;
  font-weight: 500;
}

.package-tip {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}

.tip-text {
  color: #ff9500;
}

.tip-link {
  background: none;
  border: none;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
}

.packages-list {
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
}

.package-item {
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  border: 2px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.package-item.selected {
  border-color: #ff9500;
  background: #fff8f0;
}

.package-item .badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: linear-gradient(135deg, #ff9500 0%, #ffb347 100%);
  color: white;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
}

.package-amount {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.package-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 8px;
}

.currency {
  font-size: 14px;
  color: #ff9500;
  margin-right: 2px;
}

.price {
  font-size: 32px;
  font-weight: bold;
  color: #ff9500;
}

.package-original-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
  margin-bottom: 4px;
}

.package-unit {
  font-size: 11px;
  color: #666;
}

.benefits-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.benefit-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #ff9500 0%, #ffb347 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}

.benefit-text {
  font-size: 13px;
  color: #333;
}

.payment-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.payment-info {
  display: flex;
  flex-direction: column;
}

.payment-label {
  font-size: 12px;
  color: #999;
}

.payment-amount {
  display: flex;
  align-items: baseline;
  color: #ff9500;
}

.payment-amount .currency {
  font-size: 16px;
  margin-right: 2px;
}

.payment-amount .amount {
  font-size: 28px;
  font-weight: bold;
}

.pay-button {
  flex: 1;
  background: linear-gradient(135deg, #00c853 0%, #00e676 100%);
  color: white;
  border: none;
  padding: 16px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 200, 83, 0.3);
  transition: all 0.2s ease;
}

.pay-button:active {
  transform: scale(0.98);
}

.agreement-tip {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 12px;
}

.agreement-link {
  background: none;
  border: none;
  color: #ff9500;
  cursor: pointer;
  font-size: 12px;
}
</style>
